module.exports = __webpack_public_path__ + "static/media/chatbot.735a1450.svg";